<template>
  <collapsed-section title="Emergency Contact" :open="true">
    <labeled-form-control label="Name">
      <input @blur="handleBlur" v-model="name" class="form-control" type="text" placeholder="Enter Name"/>
      <validation-message v-if="validator.name" :message="validator.name"/>
    </labeled-form-control>
    <labeled-form-control label="Mobile">
      <input @blur="handleBlur" v-model="mobile" class="form-control" type="tel" placeholder="Enter Mobile"/>
    </labeled-form-control>
  </collapsed-section>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { ContactHelper } from '@/helpers/ContactHelper'
import { StatusEmitterMixin } from '@/mixins/GeneralRegistration/StatusEmitterMixin'
import CollapsedSection from '../Layout/CollapsedSection.vue'
import LabeledFormControl from '../Layout/LabeledFormControl.vue'
import ValidationMessage from '../ErrorValidation/ValidationMessage.vue'

export default {
  name: 'AlternateContact',
  mixins: [StatusEmitterMixin],
  data () {
    return {
      validator: ContactHelper.getContactValidator()
    }
  },
  computed: {
    ...mapState('ApplicationEvents', [
      'saveClientRegistrationEvent'
    ]),
    ...mapGetters('ClientRegistrationUpload', [
      'findContact'
    ]),
    contactTypeId () {
      return 2
    },
    contact () {
      return this.findContact(this.contactTypeId)
    },
    name: {
      get () {
        return this.contact ? this.contact.name : ''
      },
      set (value) {
        this.setContactName({ contactTypeId: this.contactTypeId, value })
      }
    },
    mobile: {
      get () {
        return this.contact ? this.contact.mobile : ''
      },
      set (value) {
        this.setContactMobile({ contactTypeId: this.contactTypeId, value })
      }
    },
    altContactModel () {
      return {
        name: this.name,
        mobile: this.mobile
      }
    },
    trimmedName () {
      return (this.name || '').trim()
    },
    trimmedMobile () {
      return (this.mobile || '').trim()
    },
    hasAnyValue () {
      return !!this.trimmedName || !!this.trimmedMobile
    },
    validated () {
      return !this.hasAnyValue || !!this.trimmedName
    }
  },
  watch: {
    saveClientRegistrationEvent () {
      this.validate()
    },
    name () {
      if (this.validator.name) this.validate()
    },
    mobile () {
      if (this.validator.name) this.validate()
    }
  },
  methods: {
    ...mapMutations('ClientRegistrationUpload', [
      'setContactName',
      'setContactMobile'
    ]),
    handleBlur () {
      this.validate()
    },
    validate () {
      this.validator.check(this.altContactModel)
    }
  },
  components: {
    'collapsed-section': CollapsedSection,
    'labeled-form-control': LabeledFormControl,
    'validation-message': ValidationMessage
  }
}
</script>
